<template>
  <div class="partnerCompanyInfo">
    <!-- 展示模式：卡片网格 (Read-Only Tile Grid) -->
    <div class="infoTileGrid">
      <div
        v-for="item in displayFields"
        :key="item.label"
        class="infoTile"
      >
        <div class="tileIconWrap">
          <i :class="item.icon"></i>
        </div>
        <div class="tileMain">
          <div class="tileLabel">{{ item.label }}</div>
          <div
            class="tileValue"
            :class="{ 'is-empty': !item.value || item.value === '-' }"
          >
            {{ item.value }}
          </div>
        </div>
      </div>
    </div>

    <!-- 保留原有富文本详情 -->
    <!-- <div
      v-if="data.details"
      class="partnerCompanyInfoRich"
      v-html="data.details"
    /> -->

    <!-- 保留原有视频 -->
    <!-- <div v-if="videoList.length" class="partnerCompanyInfoVideos">
      <div
        v-for="(item, index) in videoList"
        :key="index"
        class="partnerCompanyInfoVideoBox"
      >
        <video
          class="partnerCompanyInfoVideo"
          muted
          preload
          :ref="'partnerVideo' + index"
          controls
          @play="onPlay(index)"
          @pause="onPause(index)"
        >
          <source :src="item" type="video/mp4" />
        </video>
        <img
          v-if="showBtn[index]"
          class="partnerCompanyInfoPlayBtn"
          src="@/assets/images/play.png"
          alt="播放"
          @click="togglePlay(index)"
        />
      </div>
    </div> -->
  </div>
</template>

<script>
import { AUTH_COOPERATION_TYPE, STAFF_COUNT } from "@/common/enum";

/** 从 data 中按多个候选字段取值 */
function pick(data, keys, fallback = "-") {
  if (!data || typeof data !== "object") return fallback;
  for (const key of keys) {
    const val = data[key];
    if (val !== undefined && val !== null && val !== "") return val;
  }
  return fallback;
}

export default {
  name: "PartnerCompanyInfo",
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showBtn: {},
    };
  },
  computed: {
    videoList() {
      const video = this.data && this.data.video;
      return Array.isArray(video) ? video : [];
    },
    displayFields() {
      const d = this.data || {};
      const fields = [
        {
          label: "L1授权开始日期",
          value: pick(d, ["l1AuthStartDate", "l1StartDate"]),
          icon: "el-icon-date",
        },
        {
          label: "L1授权终止日期",
          value: pick(d, ["l1AuthEndDate", "l1EndDate"]),
          icon: "el-icon-date",
        },
        {
          label: "L2授权开始日期",
          value: pick(d, ["l2AuthStartDate", "l2StartDate"]),
          icon: "el-icon-date",
        },
        {
          label: "L2授权终止日期",
          value: pick(d, ["l2AuthEndDate", "l2EndDate"]),
          icon: "el-icon-date",
        },
        {
          label: "授权合作类型",
          value: (() => {
            const val = pick(d, ["authCooperationType"], null);
            return AUTH_COOPERATION_TYPE[val] || val || "-";
          })(),
          icon: "el-icon-s-cooperation",
        },
        {
          label: "授权城市",
          value:
            d.authProvince || d.authCity
              ? `${d.authProvince || ""}${d.authCity || ""}`
              : pick(d, ["authCity", "authorizedCity", "authCityName"]),
          icon: "el-icon-location-outline",
        },
        {
          label: "对应LWS良仓",
          value: pick(d, ["lwsWarehouse"]),
          icon: "el-icon-office-building",
        },
        {
          label: "企业负责人",
          value: pick(d, ["decisionMaker"]),
          icon: "el-icon-user",
        },
        {
          label: "企业负责人联系方式",
          value: pick(d, ["decisionMakerPhone"]),
          icon: "el-icon-mobile-phone",
        },
        {
          label: "公司经营地址",
          value: pick(d, ["businessAddress"]),
          icon: "el-icon-location-information",
        },
        {
          label: "生产的盘柜类型",
          value: pick(d, ["cabinetType"]),
          icon: "el-icon-box",
        },
        {
          label: "主要行业",
          value: pick(d, ["mainIndustry"]),
          icon: "el-icon-office-building",
        },
        {
          label: "主要客户",
          value: pick(d, ["mainCustomer"]),
          icon: "el-icon-s-custom",
        },
        {
          label: "人员数量",
          value: (() => {
            const val = pick(d, ["staffCount"], null);
            return STAFF_COUNT[val] || val || "-";
          })(),
          icon: "el-icon-pie-chart",
        },
        {
          label: "友商合作情况",
          value: pick(d, ["competitorCooperation"]),
          icon: "el-icon-connection",
        },
        {
          label: "所在大区",
          value: pick(d, ["region"]),
          icon: "el-icon-map-location",
        },
        {
          label: "所在地区部",
          value: pick(d, ["regionDept"]),
          icon: "el-icon-guide",
        },
        {
          label: "良信负责人",
          value: pick(d, ["lxPrincipal"]),
          icon: "el-icon-user-solid",
        },
        {
          label: "良信负责人手机号",
          value: pick(d, ["lxPrincipalPhone"]),
          icon: "el-icon-phone-outline",
        },
      ];

      return fields;
    },
  },
  watch: {
    videoList: {
      handler(list) {
        list.forEach((_, index) => {
          this.$set(this.showBtn, index, true);
        });
      },
      immediate: true,
    },
  },
  methods: {
    getVideoEl(index) {
      const ref = this.$refs["partnerVideo" + index];
      return Array.isArray(ref) ? ref[0] : ref;
    },
    onPlay(index) {
      this.videoList.forEach((_, i) => {
        if (i === index) return;
        const video = this.getVideoEl(i);
        if (video) video.pause();
        this.$set(this.showBtn, i, true);
      });
      this.$set(this.showBtn, index, false);
    },
    onPause(index) {
      this.$set(this.showBtn, index, true);
    },
    togglePlay(index) {
      this.videoList.forEach((_, i) => {
        if (i === index) return;
        const video = this.getVideoEl(i);
        if (video) video.pause();
        this.$set(this.showBtn, i, true);
      });
      const video = this.getVideoEl(index);
      if (video) video.play();
    },
  },
};
</script>

<style lang="less" scoped>
.partnerCompanyInfo {
  padding: 32px;
  background: #fff;
  min-height: 300px;
  border-radius: 12px;
}

/* 展示模式：网格卡片 (Read-Only Tile Grid) */
.infoTileGrid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px 24px;
}

.infoTile {
  background: #f8fafc;
  border: 1px solid #f0f4f7;
  border-radius: 10px;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  transition: all 0.25s ease;

  &:hover {
    background: #ffffff;
    border-color: #d1f2ee;
    box-shadow: 0 6px 18px rgba(0, 216, 195, 0.08);
    transform: translateY(-2px);

    .tileIconWrap {
      background: #00d8c3;
      color: #ffffff;
      transform: scale(1.05);
    }
  }
}

.tileIconWrap {
  width: 42px;
  height: 42px;
  border-radius: 10px;
  background: #eef9f8;
  color: #00d8c3;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.tileMain {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.tileLabel {
  font-size: 13px;
  color: #7a8b94;
}

.tileValue {
  font-size: 15px;
  font-weight: 500;
  color: #1a252c;
  line-height: 22px;
  word-break: break-all;

  &.is-empty {
    color: #b0bec5;
    font-weight: normal;
  }
}

@media screen and (max-width: 768px) {
  .infoTileGrid {
    grid-template-columns: 1fr;
  }
}

.partnerCompanyInfoRich {
  margin-top: 32px;
  font-size: 14px;
  color: #525f66;
  line-height: 1.8;
  /deep/ img {
    max-width: 100% !important;
    height: auto !important;
  }
}
.partnerCompanyInfoVideos {
  margin-top: 24px;
}
.partnerCompanyInfoVideoBox {
  position: relative;
  margin-top: 20px;
}
.partnerCompanyInfoVideo {
  width: 100%;
  height: 480px;
  background: #00161a;
  display: block;
}
.partnerCompanyInfoPlayBtn {
  position: absolute;
  width: 80px;
  height: 80px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
}
</style>
